import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import DeleteModal from '../../../components/common/deleteModal/DeleteModal';
import { useModalState } from '../../../hooks/modalState';
import { usePermissions } from '../../../hooks/permissions';
import { useAppDispatch } from '../../../hooks/redux';
import { deleteLiveGuidelineAction } from '../../../redux/actions/liveGuidelineActions';
import { LiveGuideline } from '../../../redux/actions/liveGuidelineActions/types';
import {
    OpenActionsMenu,
    ProjectActionDropdown,
    ProjectDotsAction,
} from '../../projectInfo/projectInfoActions/ProjectInfoActions..styles';
import LiveGuidelineExportModal from '../LiveGuidelinesList/LiveGuidelineExportModal';
import { getGuidelineActions } from '../LiveGuidelinesList/LiveGuidelinesList.columns';
import NotificationModal from './tabs/modals/NotificationModal';

interface Props {
    guideline: LiveGuideline;
}

const LiveGuidelineDetailActions: React.FC<Props> = ({ guideline }) => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { canManageGuidelines } = usePermissions();
    const notificationModal = useModalState();
    const exportModal = useModalState();
    const deleteModal = useModalState();
    const [deletePending, setDeletePending] = useState(false);

    const onDeleteGuideline = async () => {
        setDeletePending(true);
        try {
            const result = await dispatch(deleteLiveGuidelineAction(guideline.id));
            if (deleteLiveGuidelineAction.fulfilled.match(result)) {
                deleteModal.onClose();
                history.push('/live-guidelines');
            }
        } finally {
            setDeletePending(false);
        }
    };

    const onMenuClick = ({ key }: { key: string }) => {
        switch (key) {
            case 'ManageNotification':
                notificationModal.onOpen();
                break;
            case 'ExportToCSV':
                exportModal.onOpen();
                break;
            case 'Delete':
                deleteModal.onOpen();
                break;
        }
    };

    return (
        <>
            <ProjectActionDropdown
                menu={{ items: getGuidelineActions(canManageGuidelines()), onClick: onMenuClick }}
                overlayClassName="projects-table-columns-dropdown"
                placement="bottomRight"
                trigger={['click']}
            >
                <OpenActionsMenu aria-label="Live Guideline actions">
                    <ProjectDotsAction />
                </OpenActionsMenu>
            </ProjectActionDropdown>
            {notificationModal.isOpen && (
                <NotificationModal
                    isOpen={notificationModal.isOpen}
                    liveGuidelineId={guideline.id}
                    handleCancel={notificationModal.onClose}
                    onSuccess={notificationModal.onClose}
                />
            )}
            {exportModal.isOpen && (
                <LiveGuidelineExportModal
                    guideline={guideline}
                    isOpen={exportModal.isOpen}
                    closeModal={exportModal.onClose}
                />
            )}
            {deleteModal.isOpen && (
                <DeleteModal
                    isOpen={deleteModal.isOpen}
                    closeModal={deleteModal.onClose}
                    reload={onDeleteGuideline}
                    title="Live Guideline"
                    text={guideline.name}
                    pending={deletePending}
                />
            )}
        </>
    );
};

export default LiveGuidelineDetailActions;
